export const TreeWithSidePanelProp = Object.freeze({
    SidePanelType: 'sidePanelType',
});